@if (item) {
<div class="container single-view" id="edit-item">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" appBack [fallbackUrl]="'/items/' + itemId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'ITEMS.BTN_BACK_TO_ITEM' | translate }}</a>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-item-title"  class="section-title">{{ 'ITEM_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="itemForm" data-testid="edit-item-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 class="border-b pb-3">{{ 'ITEM_UPDATE.ITEM_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3 disabled">
                    <label data-testid="edit-item-field-product" class="block text-sm" for="productId">{{ 'ITEM_UPDATE.PRODUCT' | translate }} <i
                        class="icon-required-field"></i></label>
                    <app-custom-dropdown
                      data-testid="product"
                      [placeholder]="'ITEM_UPDATE.SELECT_PRODUCT_PLACEHOLDER' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="false"
                      [searchMode]="'remote'"
                      [pageSize]="productRowsPerPageOption"
                      [totalCount]="productTotalRecords"
                      [totalPages]="getTotalPages(productTotalRecords, productRowsPerPageOption)"
                      [options]="products"
                      formControlName="product"
                      (onLazyLoad)="onLazyLoadProducts($event)">
                    </app-custom-dropdown>
                    @if (
                    itemForm.get('product')?.invalid &&
                    itemForm.get('product')?.touched
                    ) {
                    <small data-testid="product-mandatory" class="p-error">
                      {{ 'FORMS.MANDATORY_FIELD' | translate }}
                    </small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3 disabled">
                    <label data-testid="edit-item-field-serialnumber" class="block text-sm mb-2" for="serialNumber">{{ 'ITEM_CREATE.SERIAL_NUMBER' | translate }} <i
                        class="icon-required-field"></i></label>
                    <div class="flex items-stretch camera-btn-field-wr">
                      <input data-testid="edit-item-serialnumber-input" type="text" id="serialNumber" formControlName="serialNumber" autocomplete="off">
                      <textbox-camera class="shrink-0 self-stretch flex items-center disabled" (qrCodeScanned)="qrCodeScanned($event)"></textbox-camera>
                    </div>
                  </div>

                  @if(isPrepaired) {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 disabled">
                      <label data-testid="edit-item-field-warrantycode" class="block text-sm" for="warrantyCode">{{ 'ITEM_UPDATE.WARRANTY_CODE' | translate
                        }}</label>
                      <input data-testid="edit-item-warrantycode-input"  type="text" formControlName="warrantyCode" autocomplete="off" [disabled]=true>
                    </div>
                  }

                  @if (showSecurityCodeField) {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                      <label data-testid="edit-item-field-securitycode" class="block text-sm" for="securityCode">{{ 'ITEM_UPDATE.SECURITY_CODE' | translate
                        }}</label>
                      <input data-testid="edit-item-securitycode-input"  type="text" formControlName="securityCode" autocomplete="off">
                    </div>
                  }

                  @if (showSecurityCodeVersionField) {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                      <label data-testid="edit-item-field-securitycodeversion" class="block text-sm" for="securityCodeVersion">{{ 'ITEM_UPDATE.SECURITY_CODE_VERSION' |
                        translate }}</label>
                      <input data-testid="edit-item-securitycodeversion-input" type="text" id="securityCodeVersion" formControlName="securityCodeVersion"
                        autocomplete="off">
                    </div>
                  }

                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-item-field-productiondate" class="block text-sm" for="productionDate">{{ 'ITEM_UPDATE.PRODUCTION_DATE' | translate
                      }}</label>
                    <p-datepicker data-testid="edit-item-productiondate-input" formControlName="productionDate" dateFormat="dd-mm-yy" showIcon="true" [showTime]="false"
                      appendTo="body" />
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-item-field-warrantyduration" class="block text-sm" for="warrantyDurationMonths">{{ 'ITEM_CREATE.WARRANTY_DURATION' |
                      translate }} <i class="pi pi-question-circle"
                        pTooltip="{{ 'TOOLTIP.DURATION_IN_MONTHS' | translate }}" tooltipPosition="top"></i></label>
                    <input data-testid="edit-item-warrantyduration-input" type="number" id="warrantyDurationMonths" formControlName="warrantyDurationMonths"
                      autocomplete="off">
                    @if (
                      itemForm.get('warrantyDurationMonths')?.invalid &&
                      itemForm.get('warrantyDurationMonths')?.touched
                    ) {
                      <small data-testid="warantyduration-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  @if (companyHasCpo) {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                      <div class="row">
                        <div class="col-12">
                          <span class="label text-sm">{{ 'ITEM_UPDATE.REFURBISHED_CPO' | translate }}</span>
                          <label data-testid="edit-item-cpo-yes-label" class="inline-flex mr-6">
                            <p-radioButton data-testid="edit-item-cpo-yes" name="isCpo" value="true" formControlName="isCpo" inputId="cpo-yes" />
                            <span for="cpo-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                          </label>
                          <label data-testid="edit-item-cpo-no-label" class="inline-flex mr-2">
                            <p-radioButton data-testid="edit-item-cpo-no" name="isCpo" value="false" formControlName="isCpo" inputId="cpo-no" />
                            <span for="cpo-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <div class="row">
                      <div class="col-12">
                        <span class="label text-sm">{{ 'ITEM_UPDATE.GENUINE_PRODUCT' | translate }}</span>
                        <label data-testid="edit-item-genuine-yes-label"  class="inline-flex mr-6">
                          <p-radioButton data-testid="edit-item-genuine-yes" name="isGenuine" value="true" formControlName="isGenuine"
                            inputId="genuine-yes" />
                          <span for="genuine-yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                        </label>
                        <label data-testid="edit-item-genuine-no-label" class="inline-flex mr-2">
                          <p-radioButton data-testid="edit-item-genuine-no" name="isGenuine" value="false" formControlName="isGenuine"
                            inputId="genuine-no" />
                          <span for="genuine-no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-item-update-item-button"  class="btn primary-btn"
                        [disabled]="itemForm.invalid" (click)="submitForm()">{{
                        'ITEM_UPDATE.BTN_UPDATE_ITEM' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
